/**
 * @license @tabler/icons-vue v3.34.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createVueComponent from '../createVueComponent.mjs';

var IconAlphabetHebrew = createVueComponent("outline", "alphabet-hebrew", "IconAlphabetHebrew", [["path", { "d": "M7 6c2.333 5.143 6.611 6.857 9.333 12", "key": "svg-0" }], ["path", { "d": "M13.667 14c2.505 -1.5 2.666 -4.141 2.666 -5.333c0 -1.778 -.443 -2.667 -.443 -2.667", "key": "svg-1" }], ["path", { "d": "M7.485 18s-.485 -.905 -.485 -2.714c0 -1.172 .164 -3.722 2.641 -5.27", "key": "svg-2" }]]);

export { IconAlphabetHebrew as default };
//# sourceMappingURL=IconAlphabetHebrew.mjs.map
